if (!Element.prototype.closest) {
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	Element.prototype.closest = function (s) {
		var el = this;
		var ancestor = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (ancestor.matches(s)) return ancestor;
			ancestor = ancestor.parentElement;
		} while (ancestor !== null);
		return null;
	};
}

function closeOpenNavs() { 
  var openDrops = document.getElementsByClassName("product-select");
	for (var i = 0; i < openDrops.length; i++) {
		var openDropdown = openDrops[i];
		if (openDropdown.classList.contains('product-select--open')) {
		  openDropdown.classList.remove('product-select--open');
		}
	}  
}
                                                  
document.addEventListener('click', function (event) {

	//if not a dropdown / click outside close open navs
	if (!event.target.closest('.product-select')){
		closeOpenNavs();
		let cardWrapper = event.target.closest('.card-wrapper');
		if (cardWrapper) {
            cardWrapper.classList.remove('active');
        }
	}
	
	//if you click the trigger of an open menu, close it
	else if (event.target.closest('.v_select_button') && event.target.closest('.product-select--open')){
		console.log('open trigger');
      
        if (event.target.classList.contains('product-select--open')) {
		  event.target.closest('.product-select').classList.remove('product-select--open');
		} else {
          event.target.closest('.product-select').classList.add('product-select--open');
        };
      
		//event.target.closest('.product-select').classList.remove('product-select--open');
        let cardWrapper = event.target.closest('.card-wrapper');
		if (cardWrapper) {
            cardWrapper.classList.remove('active');
        }
	}
	//if a drop target, close any open, then open this one
	else if (event.target.closest('.product-select')){
		closeOpenNavs();
		event.target.closest('.product-select').classList.add('product-select--open');
		let cardWrapper = event.target.closest('.card-wrapper');
		if (cardWrapper) {
            cardWrapper.classList.add('active');
        }
	}
	
}, false);